import gql from 'graphql-tag'
import { graphql, QueryProps } from 'react-apollo'
import { getLocation } from '../../../location_changes/conversionHelper'

/*
export const DEFAULT_VALUES_QUERY = gql`
  query GetDefaultValues($spaceId: String!) {
    defaultValues(spaceId: $spaceId) {
      beams
      slabs
      loads
    }
  }
`*/

export const DEFAULT_VALUES_QUERY = gql`
  query GetDefaultValues($spaceId: String!, $location: String!) {
    defaultValues(spaceId: $spaceId, location: $location) {
      beams
      slabs
      loads
    }
  }
`

// Actual response data for default values query
export type DefaultValues = {
  beams: string
  slabs: string
  loads: string
}

// Input for default values query
export type ValuesInputProps = {
  spaceId: string
  location: string
}

export const withDefaultValues = graphql<
  {
    valueData: DefaultValues
  },
  /* We should really just take in space id but for now we're wrapping this
     to state which gives us appState so this is a convenient shortcut. */
  {
    currentSpaceType: string
  }
>(DEFAULT_VALUES_QUERY, {
  options: props => ({
    variables: {
      spaceId: props.currentSpaceType,
      location: getLocation()
    }
  }),
  props: ({ data }) => ({ valueData: data })
})

// Type of props the wrapped component receives
export type DefaultValueProps = {
  valueData: { defaultValues: DefaultValues } & QueryProps<ValuesInputProps>
}



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/defaultValuesQuery.ts